export default (that) => [
  {
    field: 'seq',
    width: 30,
    align: 'center',
    fixed: 'left',
    type: 'seq',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayScm') || '工厂',
    field: 'displayScm',
    align: 'left',
    minWidth: 205,
    slots: { default: 'displayScm' },
  },
  {
    title: that.$l('table_label_displayFactory') || '工厂信息',
    field: 'displayFactory',
    align: 'left',
    minWidth: 270,
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' },
  },
  {
    title: that.$l('table_label_displayOrder') || '订单信息',
    field: 'displayOrder',
    width: 190,
    showHeaderOverflow: true,
    slots: { default: 'displayOrder' },
  },
  {
    title: that.$l('table_label_qty') || '返答数量',
    field: 'qty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCtnQty') || '返答箱数',
    field: 'displayCtnQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCtnQty' },
  },
]
